exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".VHASplitPane {\n  display: flex;\n  flex-wrap: wrap; }\n  .VHASplitPane .Pane {\n    flex-shrink: 1; }\n    .VHASplitPane .Pane:not(:last-child) {\n      padding-right: 16px; }\n    .VHASplitPane .Pane:not(.isActive) {\n      opacity: 0.5;\n      pointer-events: none; }\n", ""]);

// exports
